import { Outlet, Link } from "react-router-dom";
import { useState } from 'react';
import classnames from 'classnames';

export default function NavLink({ image, title, path, children }) {

    const [isShown, setIsShown] = useState(false);

    const renderedChildren = children && children.map((child) => {
        return <Link key={child.id} to={child.path} onClick={() => setIsShown(false)}>
            <span>{child.title}</span>
        </Link>
    });

    const arrowClass = classnames(
        { 'fa fa-angle-down': children },
        { 'menu-arrow': !children },
        { 'menu-item-visible': isShown });

    const subItemClass = classnames(
        'sub-menu',
        { 'menu-sub-item-visible': isShown });

    return (
        <>
            <li onMouseEnter={() => setIsShown(true)}
                onMouseLeave={() => setIsShown(false)}>
                <Link to={path}>
                    <i className={image}></i>
                    <span>{title}</span>
                </Link>

                <i className={arrowClass}></i>

                {children && (<div className={subItemClass}> {renderedChildren}</div>)}
                <Outlet />
            </li>
        </>
    )
}
